import React from 'react';

const Footer = () => {
    return (
        <footer className="p-10">
            <div className='text-center mt-32'>
                <p>Copyright © 2022 - All right reserved by SellPhone</p>
            </div>
        </footer>
    );
};

export default Footer;